import { render, staticRenderFns } from "./IssuedVehicleDocumentLink.vue?vue&type=template&id=4945cc75&scoped=true&"
import script from "./IssuedVehicleDocumentLink.vue?vue&type=script&lang=js&"
export * from "./IssuedVehicleDocumentLink.vue?vue&type=script&lang=js&"
import style0 from "./IssuedVehicleDocumentLink.vue?vue&type=style&index=0&id=4945cc75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945cc75",
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
